/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Interop {
    import DocsAndFormsInteropService = Meevo.Plugins.DocsAndForms.DocsAndFormsInteropService;
    declare const postRobot: any;

    export class InteropService {
        private interopDomainUrl: string;
        private registeredWindows: { id: string, window: Window }[] = [];
        public get interopRegisteredWindows(): { id: string, window: Window }[] {
            return this.registeredWindows;
        }
        private get interopDomain() {
            return {
                domain: this.interopDomainUrl
            }
        }

        constructor(
            protected $cookies: angular.cookies.ICookiesService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: angular.ui.IStateService,
            docsAndFormsInteropService: DocsAndFormsInteropService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private $translate: angular.translate.ITranslateService) {

            this.interopDomainUrl = appSettings.INTEROP_URL;

            docsAndFormsInteropService.registerEvents(postRobot, this.interopDomain);

            postRobot.on(InteropActions.RefreshLockoutLastEventTime, this.interopDomain, event => {
                $rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_LOCKOUT_LAST_EVENT_TIME);
            });

            postRobot.on(InteropActions.GetSession, this.interopDomain, event => {
                return this.getSession();
            });

            postRobot.on(InteropActions.ShowModalAlert, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.alert(data.contentKey, data.translationMode, data.canShowMultiple, data.userOptions, data.headerContentKey);
            });

            postRobot.on(InteropActions.ShowModalCustom, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.showCustom({
                    templateUrl: data.options.templateUrl,
                    controller: data.options.controller,
                    controllerAs: data.options.controllerAs,
                    bindToController: data.options.bindToController,
                    locals: data.options.locals
                });
            })

            postRobot.on(InteropActions.StartBusyService, this.interopDomain, event => {
                const data = event.data;
                // seem to always need to have the timeout to get it to show
                this.busyService.start(data.messageKey, data.highVisibility, true);
            });

            postRobot.on(InteropActions.StopBusyService, this.interopDomain, event => {
                // seem to always need to have the timeout to get it to hide
                this.busyService.stop(true);
            });

            postRobot.on(InteropActions.Translate, this.interopDomain, event => {
                return this.$translate.instant(event.data);
            });

            postRobot.on(InteropActions.ShowModalConfirm, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.confirm(data.contentKey, data.translationMode, data.canShowMultiple, data.userOptions);
            });

            postRobot.on(InteropActions.ShowModalConfirmHandler, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.confirmHandler(data.contentKey, data.translationMode, data.canShowMultiple);
            });

            postRobot.on(InteropActions.ShowModalRedAlertConfirm, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.redAlertConfirm(data.contentKey, data.translationMode, data.canShowMultiple, data.userOptions);
            });

            postRobot.on(InteropActions.ShowModalInfo, this.interopDomain, event => {
                const data = event.data;
                return this.modalService.info(data.contentKey, data.translationMode, data.canShowMultiple, data.userOptions);
            });

            postRobot.on(InteropActions.CloseContext, this.interopDomain, event => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            });

            postRobot.on(InteropActions.GoToState, this.interopDomain, (event) => {
                const { data } = event;

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, data);
            });

            postRobot.on(InteropActions.CloseIntakeFormDesigner, this.interopDomain, event => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM_DESIGNER);
            });

            postRobot.on(InteropActions.ShowAuditHistoryModal, this.interopDomain, event => {
                const { data } = event;
                this.showAuditHistoryModal(data);
            });

            postRobot.on(InteropActions.ReturnFromOnHold, this.interopDomain, event => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: "register",
                    stateParams: {
                        action: Meevo.Components.Common.Messages.RETURN_FROM_ON_HOLD,
                        id: event.data
                    }
                });
            });

            postRobot.on(InteropActions.AddPaymentRequestToSale, this.interopDomain, event => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: "register",
                    stateParams: {
                        action: Meevo.Components.Common.Messages.ADD_PAYMENT_REQUEST_TO_SALE,
                        ...event.data
                    }
                });
            });

            postRobot.on(InteropActions.OpenClientChart, this.interopDomain, event => {
                let serviceIds = event.data.appointmentServiceIds;

                if (!serviceIds && event.data.clientChartAppointmentServices) {
                    serviceIds = event.data.clientChartAppointmentServices.map(s => s.appointServiceId).join(',');
                }

                const params = {
                    id: event.data.clientId,
                    period: moment(event.data.visitDate).format('YYYYMMDD'), 
                    mode: event.data.mode,
                    clientChartId: event.data.clientChartId ? event.data.clientChartId : 0,
                    locationId: event.data.locationId,
                    chartdefinitionId: event.data.chartDefinitionId,
                    chartVersionId: event.data.chartVersionId,
                    clientChartStatus: event.data.clientChartStatus,
                    appointmentServiceIds: serviceIds,
                    clientDisplayName: event.data.clientDisplayName,
                    sourceModule: event.data.sourceModule
                };
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.client,
                    stateParams: {
                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        initialEditSection: "SECTION_CLIENT_CHARTS",
                        callbackState: event.data.sourceModule,
                        ...params
                    }
                });
            });

            postRobot.on(InteropActions.SetMaintenanceFormState, this.interopDomain, event => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SET_MAINTENANCE_FORM_STATE, event);
            });

            postRobot.on(InteropActions.GetAppSettings, this.interopDomain, event => {
                return this.getAppSettings();
            });

            postRobot.on(InteropActions.GetWalkMeAppSettings, this.interopDomain, event => {
                return this.getWalkmeAppSettings();
            });

            postRobot.on(InteropActions.GetTippyServiceUrl, this.interopDomain, event => {
                return this.getTippyServiceUrl();
            });

            postRobot.on(InteropActions.GetPendoData, this.interopDomain, event => {
                return this.getPendoData();
            });

            $rootScope.$on(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS, (event: angular.IAngularEvent, args: Meevo.Components.Common.IIdentity) => {
                for (const win of this.registeredWindows) {
                    postRobot.send(win.window, InteropActions.RefreshSession, win.id, this.interopDomain)
                        .then(event => console.debug('[Meevo] send: ', event.data.message))
                        .catch(error => {
                            var contextItem = <IContext>this.$state.get(win.id);
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, contextItem, null);
                            this.removeWindow(win.id);
                            console.warn('Meevo Error', error.stack)
                        });

                }
            });

            postRobot.on(InteropActions.SendMessage, this.interopDomain, (event) => {
                const { data } = event;

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SEND_MESSAGE, data);
            });
        }

        updateInteropRoute(id, route) {
            console.debug(`updateInteropRoute: id=${id} - route=${route}`,);
            const iframeElement = document.getElementById(id) as HTMLIFrameElement;
            if (iframeElement) {
                this.registerWindow(id, iframeElement.contentWindow);
                const win = this.registeredWindows.find(w => w.id === id);
                postRobot.send(win.window, InteropActions.NavigateTo, route, this.interopDomainUrl)
                    .then(event => {
                        console.debug('[Meevo] send: ', event.data.message)
                    })
                    .catch(error => {
                        console.warn('Meevo Error', error.stack)
                    });
            }
        }

        registerWindow(id: string, window: Window) {
            const existingIndex = this.registeredWindows.findIndex(w => w.id === id);
            if (existingIndex > -1) {
                this.registeredWindows.splice(existingIndex, 1, { id: id, window: window });
                return;
            }
            this.registeredWindows.push({ id: id, window: window });
        }

        removeWindow(id: string) {
            let index = this.registeredWindows.findIndex(win => win.id === id);
            if (index < 0) { return }
            this.registeredWindows.splice(index, 1);
        }

        async pushToAllChild(event: string, payload: any) {
            for (const registeredWindow of this.registeredWindows) {
                try {
                    await postRobot.send(registeredWindow.window, event, payload, this.interopDomain);
                } catch (e) {
                    this.removeWindow(registeredWindow.id);
                }
            }
        }

        private getSession(): Meevo.Components.Common.IIdentity {
            let session = this.identityService.current();
            const win = window as any;
            if (win.bearerToken) {
                session = { ...session, ...{ bearerToken: win.bearerToken, localeId: this.appSettings.APP_COUNTRYID } };
            }
            return session;
        }

        private getAppSettings() {
            let appSettings = {
                APP_FIELDLABELS: this.appSettings.APP_FIELDLABELS,
                SECURITY_ACCESS_KEYS: this.appSettings.SECURITY_ACCESS_KEYS,
                APP_ISOCOUNTRYCODE: this.appSettings.APP_ISOCOUNTRYCODE
            };
            return appSettings;
        }

        private getWalkmeAppSettings() {
            let walkmeUrl = "";
            if (window["WalkMeUrl_ME"] && !window['pendo']) {
                walkmeUrl = window["WalkMeUrl_ME"];
                console.log(window["WalkMeUrl_ME"]);
            }

            let walkMeAppSettings = { WALKME_URL: walkmeUrl };
            return walkMeAppSettings;
        }

        private showAuditHistoryModal(auditLog) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/components/auditHistory/auditHistory.html',
                locals: {
                    auditLog,
                    userId: this.identityService.current().userId,
                    userName: this.identityService.current().userAuthName
                },
                controller: 'meevo.auditHistory.AuditHistoryController',
                controllerAs: 'auditHistory',
                bindToController: true
            };

            this.modalService.showCustom(options);
        }

        private getTippyServiceUrl() {
            return { tippyUrl: window['TippyMicroserviceUrl'] };
        }

        private getPendoData() {
            return window['pendo'] && window['pendo'].getSerializedMetadata ? 
                window['pendo'].getSerializedMetadata() :
                null;
        }

        static factory(): Function {
            let svc = ($cookies: angular.cookies.ICookiesService, appSettings: Meevo.Components.Common.IAppSettings, identityService: Meevo.Components.Common.IIdentityService, modalService: Meevo.Components.Modal.IModalService, $rootScope: angular.IRootScopeService, $state: angular.ui.IStateService, docsAndFormsInteropService: DocsAndFormsInteropService,
                busyService: Meevo.Components.Busy.IBusyService, $translate: angular.translate.ITranslateService) => {
                return new InteropService($cookies, appSettings, identityService, modalService, $rootScope, $state, docsAndFormsInteropService,
                    busyService, $translate);
            }

            svc.$inject = ['$cookies', 'meevo.AppSettings', 'meevo.components.common.IdentityService', 'meevo.components.modal.ModalService', '$rootScope', '$state', 'meevo.plugins.docsAndForms.DocsAndFormsInteropService',
                'meevo.components.busy.BusyService', "$translate"];
            return svc;
        }
    }

    angular.module('meevo.plugins.interop')
        .factory('meevo.plugins.interop.InteropService', InteropService.factory());
}
